import React from 'react';

const DemmiCardDivider: React.FC = () => {
  const CSSBlock = 'demmi-ui-card';

  return <div className={`${CSSBlock}__divider`}></div>;
};

export default DemmiCardDivider;
